import { apiRequest } from '../../services/apiClient';
import { apiUrl } from '../../config/api';

export function listReviews({ status, type, aiClassification, q, sort, order, page, pageSize } = {}) {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  if (type) params.set('type', type);
  if (aiClassification) params.set('aiClassification', aiClassification);
  if (q) params.set('q', q);
  if (sort) params.set('sort', sort);
  if (order) params.set('order', order);
  if (page) params.set('page', page);
  if (pageSize) params.set('pageSize', pageSize);
  const qs = params.toString();
  return apiRequest(`/reviews${qs ? `?${qs}` : ''}`);
}

export function getReview(id) {
  return apiRequest(`/reviews/${id}`);
}

export function submitReview(file, { title } = {}) {
  const body = new FormData();
  body.append('file', file);
  if (title) body.append('title', title);
  return apiRequest('/reviews', { method: 'POST', body });
}

export function decideReview(id, { action, notes }) {
  return apiRequest(`/reviews/${id}/review`, { json: { action, notes } });
}

export function rerunReviewTriage(id) {
  return apiRequest(`/reviews/${id}/rerun-triage`, { method: 'POST' });
}

export function withdrawReview(id) {
  return apiRequest(`/reviews/${id}/withdraw`, { method: 'POST' });
}

export function reviewDocumentUrl(id) {
  return apiUrl(`/reviews/${id}/document`);
}
